import { NgModule, APP_INITIALIZER } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DayPilotModule } from 'daypilot-pro-angular';
import { T4coreModule } from 't4core';
import { AuthGuard } from 't4core';
import { T4CommonModule } from '../../t4common/t4common';
import { Calendar } from './views/calendar/calendar';
import { ClerkDashboardComponent } from './views/ClerkDashboard/ClerkDashboard';
import { CustomersComponent } from './views/customers/customers.component';
import { HomeComponent } from './views/home/home.component';
import { TrailerHeightWarningDialog } from './dialogs/trailerHeightWarningDialog/trailerHeightWarningDialog';
import { UIService } from 't4core';
import { RefundDialog } from './dialogs/RefundDialog/RefundDialog';
import { AddCostDialog } from './dialogs/AddCostDialog/AddCostDialog';
import { RequestPaymentDialog } from './dialogs/RequestPaymentDialog/RequestPaymentDialog';
import { PaymentRequestStatusPipe, PaymentRequestsComponent } from './views/PaymentRequests/paymentrequests.component';
import { CostListDialog } from './dialogs/CostListDialog/CostListDialog';
import { TheftDialog } from './dialogs/TheftDialog/TheftDialog';
import { OrderServiceDialog } from './dialogs/OrderServiceDialog/OrderServiceDialog';
import { CompanyCustomersComponent } from './views/companyCustomers/companyCustomers.component';
import { NewCompanyDialog } from './dialogs/NewCompanyDialog/NewCompanyDialog';


@NgModule({
    declarations: [
        HomeComponent,
        PaymentRequestsComponent,
        ClerkDashboardComponent,
        Calendar,
        CustomersComponent,
        TrailerHeightWarningDialog,
        RefundDialog,
        AddCostDialog,
        PaymentRequestStatusPipe,
        RequestPaymentDialog,
        CostListDialog,
        TheftDialog,
        OrderServiceDialog,
        CompanyCustomersComponent,
        NewCompanyDialog
    ],
    imports: [
        T4CommonModule,
        DayPilotModule,
        T4coreModule,
        RouterModule.forChild([
            {
                path: 'Bookings',
                canActivate: [AuthGuard],
            data: { index: 1, title: "Bookings", toolTip: "Manage your bookings", roles: ['Clerk', 'LocationManager', 'GroupManager', 'Admin', 'Sales', 'BusinessManager'], skipbrands: ['Use4Free'], icon: 'today' },
                children: [
                    { path: '', redirectTo: 'Calendar', pathMatch: 'full' },
                    {
                        path: "Dashboard",
                        canActivate: [AuthGuard],
                        component: HomeComponent,
                      data: { title: "Dashboard", toolTip: "Dashboard", roles: ['LocationManager', 'GroupManager', 'Admin', 'Sales', 'BusinessManager'], skipbrands: ['Use4Free'], icon: 'bar_chart' }
                    },
                    {
                      path: "Payment requests",
                      canActivate: [AuthGuard],
                      component: PaymentRequestsComponent,
                      data: { title: "Payment Requests", toolTip: "Payment Requests", roles: ['Admin', 'Backoffice'], icon: 'payments' }
                    },
                    {
                        path: "UserDashboard",
                        canActivate: [AuthGuard],
                        component: ClerkDashboardComponent,
                        data: { title: "Dashboard", toolTip: "Dashboard", roles: ['Clerk'], icon: 'bar_chart' }
                    },
                    {
                        path: "Calendar",
                        canActivate: [AuthGuard],
                        component: Calendar,
                        data: { title: "Bookings", toolTip: "My bookings", roles: ['Clerk', 'LocationManager'], icon: 'today' }
                    },
                    {
                        path: "CustomerList",
                        canActivate: [AuthGuard],
                        component: CustomersComponent,
                        data: { title: "Customer list", toolTip: "Customer list", roles: ['GroupManager', 'LocationManager'], icon: 'person' }
                  },
                  {
                    path: "CompanyList",
                    canActivate: [AuthGuard],
                    component: CompanyCustomersComponent,
                    data: { title: "Company list", toolTip: "Company list", roles: ['GroupManager', 'LocationManager'], icon: 'apartment' }
                  },
                ]
            },
        ])
    ],
    providers: [T4CommonModule, { provide: APP_INITIALIZER, useFactory: initModule, deps: [UIService], multi: true }]
})
export class BookingsModule { }

// Module initialization
export function initModule(settings: UIService) {
  return () => {
    settings.applySettings({
      dialogs: [
        { key: "T4.Bookings.TrailerHeightWarningDialog", dialog: TrailerHeightWarningDialog },
        { key: "T4.Bookings.RefundDialog", dialog: RefundDialog },
        { key: "T4.Bookings.AddCostDialog", dialog: AddCostDialog },
        { key: "T4.Bookings.CostListDialog", dialog: CostListDialog },
        { key: "T4.Bookings.RequestPaymentDialog", dialog: RequestPaymentDialog },
        { key: "T4.Bookings.TheftDialog", dialog: TheftDialog },
        { key: "T4.Bookings.OrderServiceDialog", dialog: OrderServiceDialog },
        { key: "T4.Bookings.NewCompanyDialog", dialog: NewCompanyDialog }
      ]
    });
  };
}
// Module initialization
